var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 28.5H10.5V15.9C10.5 15.6613 10.5948 15.4324 10.7636 15.2636C10.9324 15.0948 11.1613 15 11.4 15H18.6C18.8387 15 19.0676 15.0948 19.2364 15.2636C19.4052 15.4324 19.5 15.6613 19.5 15.9V28.5V28.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 28.5H19.5V24.15C19.5 23.9113 19.5948 23.6824 19.7636 23.5136C19.9324 23.3448 20.1613 23.25 20.4 23.25H27.6C27.8387 23.25 28.0676 23.3448 28.2364 23.5136C28.4052 23.6824 28.5 23.9113 28.5 24.15V27.6C28.5 27.8387 28.4052 28.0676 28.2364 28.2364C28.0676 28.4052 27.8387 28.5 27.6 28.5V28.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 28.5V21.15C10.5 20.9113 10.4052 20.6824 10.2364 20.5136C10.0676 20.3448 9.83869 20.25 9.6 20.25H2.4C2.16131 20.25 1.93239 20.3448 1.7636 20.5136C1.59482 20.6824 1.5 20.9113 1.5 21.15V27.6C1.5 27.8387 1.59482 28.0676 1.7636 28.2364C1.93239 28.4052 2.16131 28.5 2.4 28.5H10.5V28.5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.209 4.66951L14.5725 1.77901C14.6093 1.69638 14.6693 1.62619 14.7451 1.57693C14.821 1.52767 14.9095 1.50145 15 1.50145C15.0904 1.50145 15.179 1.52767 15.2548 1.57693C15.3307 1.62619 15.3907 1.69638 15.4275 1.77901L16.7925 4.66951L19.8405 5.13601C20.232 5.19601 20.388 5.70001 20.1045 5.98801L17.8995 8.23801L18.42 11.415C18.486 11.823 18.078 12.135 17.727 11.9415L15 10.4415L12.273 11.9415C11.9235 12.1335 11.514 11.823 11.58 11.415L12.1005 8.23801L9.89548 5.98801C9.61048 5.70001 9.76798 5.19601 10.158 5.13601L13.209 4.67101V4.66951Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseResults);
export default __webpack_public_path__ + "static/media/course-results.a9ad7b512af1c8a66159e0aead32b4c2.svg";
export { ForwardRef as ReactComponent };